const createAction = (type, payload = {}, meta = {}) => ({ type, payload, meta });

export default createAction;


// WEBPACK FOOTER //
// ./src/actions/utils/createAction.js